export const CFR_CATEGORIES = [
  {
    value: 'community_health',
    label: 'Community Health',
    icon: '❤️',
    summary: 'Physical health, mental health, prevention, and access to care.',
    redFlags: ['Suicide mortality', 'Sexually transmitted infections', 'Child abuse and neglect'],
    blueRibbons: ['Mental health', 'Family Connects', 'Declining overdose deaths'],
  },
  {
    value: 'housing',
    label: 'Housing',
    icon: '🏠',
    summary: 'Safe, affordable, and accessible housing.',
    redFlags: ['Shortage of accessible housing', 'Shortage of affordable housing', 'Shortage of safe housing'],
    blueRibbons: ['Civic engagement and collaboration', 'Response to blighted properties', 'Initiatives to increase home ownership'],
  },

  {
    value: 'education',
    label: 'Education',
    icon: '📚',
    summary: 'School readiness, student support, graduation, and pathways to opportunity.',
    redFlags: ['Achievement gaps', 'Social challenges', 'Recruiting and retaining critical support staff'],
    blueRibbons: ['Collaborative culture', 'Partnerships with community organizations', 'Graduation rate'],
  },
  {
    value: 'early_childhood',
    label: 'Early Childhood',
    icon: '🧒',
    summary: 'Early childhood, family support, child safety, and services for young people.',
    redFlags: ['Access to child care', 'Access to mental health services for families', 'Racial and economic disparities'],
    blueRibbons: ['Development of new facilities', 'Early support and interventions for families', 'Community awareness'],
  },
  {
    value: 'public_safety',
    label: 'Public Order & Safety',
    icon: '🛡️',
    summary: 'Community safety, crisis response, substance-use issues, and justice-system capacity.',
    redFlags: ['Gun-related crimes', 'Substance-use issues', 'Staffing shortages'],
    blueRibbons: ['Community collaboration', 'Awareness, education and response to mental health', 'Enhanced technology use'],
  },
  
  {
    value: 'citizen_participation',
    label: 'Citizen Participation',
    icon: '🗳️',
    summary: 'Volunteerism, civic input, voting access, and community engagement.',
    redFlags: ['Low participation on boards and commissions', 'Voter turnout', 'Polarization'],
    blueRibbons: ['Civic engagement', 'Interest in volunteering', 'Improved voter access'],
  },
  {
    value: 'business_economic',
    label: 'Business & Economic Development',
    icon: '💼',
    summary: 'Workforce, wages, entrepreneurship, and economic opportunity.',
    redFlags: ['Skilled labor shortage', 'Continued need to address wages', 'Redevelopment challenges'],
    blueRibbons: ['Economic strength and consistent growth', 'Welcoming environment for entrepreneurs, startups and young professionals', 'Strong support for public education'],
  },
  {
    value: 'arts_culture',
    label: 'Arts & Culture',
    icon: '🎭',
    summary: 'Creative life, cultural access, audience engagement, and arts sustainability.',
    redFlags: ['Funding challenges', 'Human capital', 'Physical infrastructure'],
    blueRibbons: ['Audience engagement', 'Collaborative approach', 'Regional travel for cultural experiences'],
  },
  {
    value: 'natural_environment',
    label: 'Natural Environment',
    icon: '🌳',
    summary: 'Water, air, land, conservation, and environmental quality.',
    redFlags: ['Regional drinking water supply', 'Outdated, inefficient garbage collection', 'Uncertainty surrounding state legislation'],
    blueRibbons: ['Generally healthy natural environment', 'Stable, established nonprofits', 'Long-term regional plans include environmental concerns'],
  },
  {
    value: 'recreation_leisure',
    label: 'Recreation, Sports & Leisure',
    icon: '⚽',
    summary: 'Parks, trails, sports, recreation access, and quality of life.',
    redFlags: ['Greenspace preservation', 'Obesity', 'Stable, long-term funding'],
    blueRibbons: ['Community collaboration', 'Trails and connections', 'Sports tourism'],
  },
  {
    value: 'transportation',
    label: 'Transportation',
    icon: '🚌',
    summary: 'Transit, trails, traffic safety, and access to work, school, services, and care.',
    redFlags: ['Traffic safety', 'Community support for public transit', 'Funding for maintenance of existing trails and sidewalks'],
    blueRibbons: ['Continued trail development', 'City Utilities Transit', 'Traffic safety efforts'],
  }
];

export const getCfrCategory = value =>
  CFR_CATEGORIES.find(c => c.value === value);

export const getCfrLabel = value =>
  getCfrCategory(value)?.label || value;

export const getCfrIcon = value =>
  getCfrCategory(value)?.icon || '◎';